import React, { useEffect, useState } from 'react';
import '../Styles/Auth.css';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImage from "../assets/login_img.jpg";
import Loader from "../Components/Loader";
import Chatbot from './Chatbot';

function Login() {
  const [userType, setUserType] = useState('');
  const [userCode, setUserCode] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const navigate = useNavigate();




  // Check for existing token and role
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('userRole');

    if (token && role) {
      // Redirect user to respective dashboard
      if (role === 'super admin') {
        navigate('/superadmin');
      } else if (role === 'admin') {
        navigate('/admin');
      } else if (role === 'faculty') {
        navigate('/faculty');
      } else if (role === 'student') {
        navigate('/student');
      }
    }
  }, [navigate]);


  const handleImageLoad = () => {
    setImageLoading(false);
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('https://api.uniums.com/api/auth/login', {
        userType,
        userCode,
        password,
      });
      const { token, role } = response.data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('userRole', role);
      toast.success('Login successful! Redirecting...', { autoClose: 2000 });
      setTimeout(() => {
        if (role === 'super admin') {
          navigate('/superadmin');
        } else if (role === 'admin') {
          navigate('/admin');
        } else if (role === 'faculty') {
          navigate('/faculty');
        } else if (role === 'student') {
          navigate('/student');
        }
      }, 500);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer />
      <div className="login-wrapper">
        <div className="slider-section">
        {imageLoading && (
            <div className="image-loader-container">
              <Loader />
            </div>
          )}
          <img 
            src={loginImage} 
            alt='Login' 
            style={{ display: imageLoading ? 'none' : 'block' }}
            onLoad={handleImageLoad}
          />
        </div>
        <div className="login-form-section">
          <div className="login-form">
            <h1>UNIUMS</h1>
            <p className="login-subtitle">Manage your UMS activities seamlessly</p>

            {loading ? (
              <Loader />
            ) : (
              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label htmlFor="userType">Select User Type</label>
                  <select
                    id="userType"
                    name="userType"
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                    required
                  >
                    <option value="">-- Select --</option>
                    <option value="admin">Admin</option>
                    <option value="faculty">Faculty</option>
                    <option value="student">Student</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="userCode">User Code</label>
                  <input
                    type="text"
                    id="userCode"
                    name="userCode"
                    placeholder="Enter your user code"
                    value={userCode}
                    onChange={(e) => setUserCode(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group form-remember">
                  <div className='remember_box'>
                    <input type="checkbox" name="rememberMe" id="remember" />
                    <label htmlFor="remember">Remember</label>
                  </div>
                  <Link to={"/forgot-password"} className="forgot-password-link">
                    Forgot Password?
                  </Link>
                </div>

                <button type="submit" className="login-button">
                  Login
                </button>
              </form>
            )}
          </div>
          <p className='terms_condition'><Link to="/privacy-policy" className='terms_a'>Privacy Policy</Link> | <Link to="/terms-conditions" className='terms_a'>Terms & Conditions</Link></p>
        </div>
      </div>
      <Chatbot />
    </div>
  );
}

export default Login;
